import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./starbucks_consumption_type.js";
//#region src/starbucks_consumption_type_helper.ts
var starbucks_consumption_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(consumptionType) {
	switch (consumptionType) {
		case "ConsumeInStore": return "In-Store";
		case "ConsumeOutOfStore": return "Out-of-Store";
	}
}
//#endregion
export { name, starbucks_consumption_type_helper_exports };

//# sourceMappingURL=starbucks_consumption_type_helper.js.map